export const legal = {
  // Legal Pages
  legalNotice: 'Juridische Vermeldingen',
  privacyPolicy: 'Privacybeleid',
  cookiePolicy: 'Cookiebeleid',
  termsOfUse: 'Gebruiksvoorwaarden',
  dataProtection: 'Gegevensbescherming',
  
  // Common
  lastUpdated: 'Laatste update',
  effectiveDate: 'Ingangsdatum',
  home: 'Home',
  otherLegalInfo: 'Andere juridische informatie',
  
  // Cookie Consent
  cookieTitle: 'We gebruiken cookies',
  cookieMessage: 'We gebruiken cookies om uw ervaring op onze site te verbeteren. Door verder te surfen, accepteert u ons gebruik van cookies.',
  cookieAccept: 'Accepteren',
  cookieDecline: 'Weigeren',
  cookieLearnMore: 'Meer informatie',

  // ========== MENTIONS LÉGALES / JURIDISCHE VERMELDINGEN ==========
  legalNoticeTitle: 'Juridische Vermeldingen',
  legalNoticeDescription: 'Wettelijke informatie over onze website en ons bedrijf',
  
  // Éditeur du site
  sitePublisher: 'Uitgever van de Website',
  company: 'Bedrijf',
  legalForm: 'Rechtsvorm',
  individualCompany: 'Eenmanszaak',
  vat: 'BTW-nr',
  headquarters: 'Maatschappelijke zetel',
  phone: 'Telefoon',
  email: 'E-mail',
  publicationManager: 'Publicatieverantwoordelijke',
  
  // Hébergement
  siteHosting: 'Hosting van de Website',
  host: 'Host',
  website: 'Website',
  hostingNote: 'De hosting wordt verzorgd door Vercel, dat voldoet aan de Europese normen inzake gegevensbescherming.',
  
  // Propriété intellectuelle
  intellectualProperty: 'Intellectuele Eigendom',
  intellectualPropertyText1: 'Alle elementen van deze website (structuur, teksten, afbeeldingen, logo\'s, video\'s, etc.) zijn beschermd door intellectuele eigendomsrechten en behoren toe aan Ktran of zijn partners.',
  intellectualPropertyText2: 'Elke reproductie, weergave, aanpassing of exploitatie, geheel of gedeeltelijk, van de inhoud van deze website, met welk middel of proces dan ook, zonder voorafgaande schriftelijke toestemming van Ktran, is strikt verboden.',
  intellectualPropertyText3: 'Niet-naleving van dit verbod vormt een inbreuk die kan leiden tot burgerlijke en strafrechtelijke aansprakelijkheid van de overtreder.',
  exception: 'Uitzondering',
  exceptionText: 'U mag de inhoud van deze website alleen raadplegen voor strikt persoonlijk en privégebruik.',
  
  // Responsabilité
  limitationOfLiability: 'Beperking van Aansprakelijkheid',
  liabilityText1: 'Ktran streeft ernaar nauwkeurige en actuele informatie op deze website te verstrekken. Wij kunnen echter niet garanderen dat alle informatie foutloos, volledig of actueel is.',
  liabilityText2: 'Ktran kan niet aansprakelijk worden gesteld voor:',
  liabilityList1: 'Directe of indirecte schade die voortvloeit uit het gebruik van deze website',
  liabilityList2: 'Tijdelijke onbeschikbaarheid van de website wegens technische problemen',
  liabilityList3: 'Eventuele fouten of weglatingen in de verstrekte informatie',
  liabilityList4: 'Schade veroorzaakt door virussen of andere schadelijke elementen',
  liabilityNote: 'De op deze website verstrekte informatie is louter indicatief. Alleen een formele offerte na een bezoek ter plaatse heeft contractuele waarde.',
  
  // Liens hypertextes
  hyperlinks: 'Hyperlinks',
  hyperlinksText1: 'Deze website kan links naar externe websites van derden bevatten. Ktran heeft geen controle over de inhoud van deze websites en kan niet aansprakelijk worden gesteld voor hun inhoud.',
  hyperlinksText2: 'Het plaatsen van een link naar onze website vereist voorafgaande schriftelijke toestemming van Ktran.',
  
  // Droit applicable
  applicableLaw: 'Toepasselijk Recht',
  applicableLawText1: 'Deze juridische vermeldingen zijn onderworpen aan het Belgische recht.',
  applicableLawText2: 'Bij geschillen zijn uitsluitend de rechtbanken van Brussel bevoegd, tenzij anders bepaald door dwingende wettelijke bepalingen.',
  gdprCompliance: 'Naleving van de AVG',
  gdprComplianceText: 'Ktran verbindt zich ertoe de Algemene Verordening Gegevensbescherming (AVG) na te leven voor alle verwerking van persoonsgegevens.',
  
  // Contact
  contactUs: 'Neem Contact met Ons Op',
  contactUsText: 'Voor vragen over deze juridische vermeldingen kunt u contact met ons opnemen:',
  address: 'Adres',

  // ========== POLITIQUE DE CONFIDENTIALITÉ / PRIVACYBELEID ==========
  privacyPolicyTitle: 'Privacybeleid',
  privacyPolicyDescription: 'Hoe wij uw persoonsgegevens verzamelen, gebruiken en beschermen',
  
  // Introduction
  privacyCommitment: 'Onze Toewijding aan Uw Privacy',
  privacyCommitmentText: 'Ktran hecht groot belang aan de bescherming van uw persoonsgegevens. Dit privacybeleid legt uit hoe wij uw gegevens verzamelen, gebruiken, opslaan en beschermen in overeenstemming met de Algemene Verordening Gegevensbescherming (AVG).',
  
  // Responsable du traitement
  dataController: 'Verwerkingsverantwoordelijke',
  enterprise: 'Onderneming',
  
  // Données collectées
  personalDataCollected: 'Verzamelde Persoonsgegevens',
  identificationData: 'Identificatiegegevens',
  nameAndSurname: 'Naam en voornaam',
  emailAddress: 'E-mailadres',
  phoneNumber: 'Telefoonnummer',
  postalAddress: 'Postadres',
  
  projectData: 'Projectgegevens',
  desiredWorkType: 'Type gewenste werken',
  housingType: 'Type woning',
  projectDescription: 'Projectbeschrijving',
  projectPhotos: 'Foto\'s van het project',
  estimatedBudget: 'Geschat budget',
  
  navigationData: 'Navigatiegegevens',
  ipAddress: 'IP-adres',
  browserType: 'Type browser',
  pagesVisited: 'Bezochte pagina\'s',
  visitDateTime: 'Datum en tijd van bezoek',
  cookies: 'Cookies',
  
  // Finalités du traitement
  processingPurposes: 'Doeleinden van de Verwerking',
  processingPurposesText: 'Wij verzamelen en verwerken uw persoonsgegevens voor de volgende doeleinden:',
  quoteManagement: 'Beheer van Offerteaanvragen',
  quoteManagementDesc: 'Verwerking van uw aanvragen, voorbereiding van offertes en opvolging van uw project.',
  clientCommunication: 'Communicatie met Klanten',
  clientCommunicationDesc: 'Beantwoorden van uw vragen, verstrekken van informatie over onze diensten en opvolging van uw dossier.',
  serviceImprovement: 'Verbetering van Onze Diensten',
  serviceImprovementDesc: 'Analyse van het gebruik van onze website om onze diensten en gebruikerservaring te verbeteren.',
  legalObligations: 'Wettelijke Verplichtingen',
  legalObligationsDesc: 'Naleving van onze wettelijke en reglementaire verplichtingen (boekhouding, belastingen, etc.).',
  
  // Base légale
  legalBasis: 'Rechtsgrondslag',
  legalBasisText: 'De verwerking van uw persoonsgegevens is gebaseerd op:',
  consent: 'Toestemming',
  consentText: 'U geeft uw uitdrukkelijke toestemming bij het invullen van onze formulieren.',
  contractExecution: 'Uitvoering van een Contract',
  contractExecutionText: 'De verwerking is noodzakelijk voor de uitvoering van de diensten die u aanvraagt.',
  legitimateInterest: 'Gerechtvaardigd Belang',
  legitimateInterestText: 'Verbetering van onze diensten en communicatie over onze activiteiten.',
  legalObligation: 'Wettelijke Verplichting',
  legalObligationText: 'Naleving van onze boekhoudkundige, fiscale en juridische verplichtingen.',
  
  // Durée de conservation
  retentionPeriod: 'Bewaartermijn',
  retentionPeriodText: 'Uw persoonsgegevens worden bewaard voor de duur die noodzakelijk is voor de doeleinden waarvoor ze zijn verzameld:',
  dataType: 'Type Gegevens',
  retentionDuration: 'Bewaartermijn',
  quoteRequests: 'Offerteaanvragen',
  threeYears: '3 jaar na de aanvraag',
  clientData: 'Klantgegevens',
  tenYears: '10 jaar (boekhoudkundige verplichting)',
  navigationDataCookies: 'Navigatiegegevens (cookies)',
  thirteenMonthsMax: 'Maximum 13 maanden',
  projectPhotosData: 'Foto\'s en projectgegevens',
  projectDurationPlusThree: 'Duur van het project + 3 jaar',
  retentionNote: 'Na deze termijnen worden uw gegevens verwijderd of geanonimiseerd, tenzij een langere bewaring wettelijk verplicht is.',
  
  // Droits des utilisateurs
  yourRights: 'Uw Rechten',
  yourRightsText: 'Conform de AVG heeft u de volgende rechten met betrekking tot uw persoonsgegevens:',
  rightOfAccess: 'Recht op Toegang',
  rightOfAccessDesc: 'U kunt een kopie opvragen van alle gegevens die wij over u bewaren.',
  rightOfRectification: 'Recht op Rectificatie',
  rightOfRectificationDesc: 'U kunt verzoeken om onjuiste of onvolledige gegevens te corrigeren.',
  rightToErasure: 'Recht op Verwijdering',
  rightToErasureDesc: 'U kunt verzoeken om uw gegevens te verwijderen onder bepaalde voorwaarden.',
  rightToRestriction: 'Recht op Beperking',
  rightToRestrictionDesc: 'U kunt verzoeken om de verwerking van uw gegevens te beperken.',
  rightToPortability: 'Recht op Overdraagbaarheid',
  rightToPortabilityDesc: 'U kunt uw gegevens in een gestructureerd formaat ontvangen.',
  rightToObject: 'Recht van Bezwaar',
  rightToObjectDesc: 'U kunt bezwaar maken tegen de verwerking van uw gegevens.',
  
  howToExerciseRights: 'Hoe Uw Rechten Uitoefenen?',
  howToExerciseRightsText: 'Om uw rechten uit te oefenen, kunt u contact met ons opnemen via:',
  mail: 'Post',
  responseTime: 'Wij verbinden ons ertoe binnen één maand op uw verzoek te antwoorden.',
  
  // Sécurité
  dataSecurity: 'Beveiliging van Gegevens',
  dataSecurityText: 'Wij implementeren passende technische en organisatorische maatregelen om uw persoonsgegevens te beschermen tegen:',
  accidentalDestruction: 'Onopzettelijke vernietiging',
  accidentalLoss: 'Onopzettelijk verlies',
  unauthorizedAccess: 'Ongeautoriseerde toegang',
  illegalProcessing: 'Onwettige verwerking',
  
  securityMeasures: 'Beveiligingsmaatregelen',
  sslEncryption: 'SSL/TLS-versleuteling voor gegevensoverdracht',
  gdprHosting: 'Hosting bij een AVG-conforme provider',
  restrictedAccess: 'Beperkte toegang tot gegevens',
  regularBackups: 'Regelmatige back-ups',
  incidentMonitoring: 'Monitoring van beveiligingsincidenten',
  
  // Partage des données
  dataSharing: 'Delen van Gegevens',
  dataSharingText1: 'Wij verkopen of verhuren uw persoonsgegevens nooit aan derden.',
  dataSharingText2: 'Uw gegevens kunnen worden gedeeld met:',
  serviceProviders: 'Dienstverleners',
  serviceProvidersDesc: 'Hosting, e-mail, technische ondersteuning (allen gebonden door vertrouwelijkheidsverplichtingen).',
  legalObligationsSharing: 'Wettelijke Verplichtingen',
  legalObligationsSharingDesc: 'Indien vereist door de wet of een gerechtelijk bevel.',
  subcontractors: 'Onderaannemers',
  subcontractorsDesc: 'Voor de uitvoering van uw project (met uw voorafgaande toestemming).',
  euLocation: 'Al onze dienstverleners zijn gevestigd in de Europese Unie en voldoen aan de AVG.',
  
  // Réclamation
  rightToComplain: 'Recht op Klacht',
  rightToComplainText: 'Als u van mening bent dat uw rechten niet worden gerespecteerd, kunt u een klacht indienen bij de Belgische toezichthoudende autoriteit:',
  dataProtectionAuthority: 'Gegevensbeschermingsautoriteit (GBA)',
  belgiumAddress: 'Drukpersstraat 35, 1000 Brussel, België',
  
  // Modifications
  policyModifications: 'Wijzigingen van het Beleid',
  policyModificationsText: 'Wij behouden ons het recht voor dit privacybeleid te allen tijde te wijzigen. Wijzigingen worden op deze pagina gepubliceerd met de datum van de laatste update.',

  // ========== CONDITIONS D'UTILISATION / GEBRUIKSVOORWAARDEN ==========
  termsOfUseTitle: 'Gebruiksvoorwaarden',
  termsOfUseDescription: 'Algemene voorwaarden voor het gebruik van onze website en diensten',
  
  // Acceptation des conditions
  acceptanceOfTerms: 'Aanvaarding van de Voorwaarden',
  acceptanceText: 'Door toegang te krijgen tot en gebruik te maken van deze website, aanvaardt u deze gebruiksvoorwaarden zonder voorbehoud. Als u niet akkoord gaat met deze voorwaarden, verzoeken wij u de website niet te gebruiken.',
  
  // Objet
  purpose: 'Doel',
  purposeText1: 'Deze gebruiksvoorwaarden regelen de toegang tot en het gebruik van de website ktran-renovation.be (hierna "de Website" genoemd), uitgegeven door Ktran.',
  purposeText2: 'De Website heeft tot doel informatie te verstrekken over onze renovatie- en bouwdiensten in Brussel en omgeving, en gebruikers in staat te stellen offerteaanvragen in te dienen.',
  
  // Accès au site
  siteAccess: 'Toegang tot de Website',
  siteAccessText1: 'De toegang tot de Website is gratis. Alle kosten in verband met de toegang tot de Website, of het nu gaat om hardware-, software- of internettoegangkosten, zijn voor rekening van de gebruiker.',
  siteAccessText2: 'Ktran streeft ernaar de Website 24 uur per dag, 7 dagen per week toegankelijk te maken, maar is niet verplicht dit te doen.',
  serviceInterruptions: 'Onderbrekingen van de Dienst',
  serviceInterruptionsText: 'De toegang tot de Website kan tijdelijk worden onderbroken voor onderhoud, updates of om technische redenen, zonder voorafgaande kennisgeving.',
  
  // Services proposés
  servicesOffered: 'Aangeboden Diensten',
  servicesOfferedText1: 'De Website biedt de volgende diensten:',
  servicesOfferedList1: 'Presentatie van onze renovatie- en bouwdiensten',
  servicesOfferedList2: 'Weergave van onze gerealiseerde projecten',
  servicesOfferedList3: 'Online offerteaanvraagformulier',
  servicesOfferedList4: 'Contactinformatie en geografische locatie',
  servicesOfferedNote: 'De op de Website verstrekte informatie is louter indicatief en niet-contractueel. Alleen een formele schriftelijke offerte heeft contractuele waarde.',
  
  // Obligations de l'utilisateur
  userObligations: 'Verplichtingen van de Gebruiker',
  userObligationsText: 'Door de Website te gebruiken, verbindt u zich ertoe:',
  prohibitedUses: 'Verboden Gebruik',
  prohibitedUsesList1: 'De Website niet te gebruiken voor illegale of frauduleuze doeleinden',
  prohibitedUsesList2: 'Geen valse of misleidende informatie te verstrekken',
  prohibitedUsesList3: 'Geen virussen of schadelijke code te verspreiden',
  prohibitedUsesList4: 'Geen inbreuk te maken op de rechten van derden',
  prohibitedUsesList5: 'Niet te proberen ongeautoriseerde toegang te krijgen tot de Website',
  prohibitedUsesList6: 'De Website niet te gebruiken voor spam of ongewenste reclame',
  prohibitedUsesList7: 'De intellectuele eigendomsrechten van Ktran te respecteren',
  userObligationsText2: 'Elke schending van deze verplichtingen kan leiden tot onmiddellijke beëindiging van uw toegang tot de Website en juridische stappen.',
  
  // Demandes de devis
  quoteRequestsSection: 'Offerteaanvragen',
  quoteRequestsText1: 'De Website stelt u in staat om online een offerteaanvraag in te dienen voor renovatie- of bouwwerken.',
  requestProcess: 'Aanvraagproces',
  requestProcessStep1: 'Invullen van het online formulier met uw projectgegevens',
  requestProcessStep2: 'Verzending van uw aanvraag naar Ktran',
  requestProcessStep3: 'Analyse van uw aanvraag door ons team',
  requestProcessStep4: 'Mogelijk bezoek ter plaatse voor een nauwkeurige evaluatie',
  requestProcessStep5: 'Verzending van een gedetailleerde en vrijblijvende offerte',
  important: 'Belangrijk',
  quoteRequestsNote: 'Het indienen van een offerteaanvraag vormt geen contractuele verplichting. De offerte is 30 dagen geldig vanaf de verzenddatum, tenzij anders vermeld.',
  
  // Propriété intellectuelle
  intellectualPropertySection: 'Intellectuele Eigendom',
  intellectualPropertySectionText1: 'Alle elementen van de Website (structuur, teksten, afbeeldingen, logo\'s, video\'s, grafische elementen, etc.) zijn beschermd door intellectuele eigendomsrechten en zijn het exclusieve eigendom van Ktran of zijn partners.',
  intellectualPropertySectionText2: 'Elke reproductie, weergave, aanpassing of exploitatie, geheel of gedeeltelijk, van de inhoud van de Website, met welk middel of proces dan ook, zonder voorafgaande schriftelijke toestemming van Ktran, is strikt verboden en vormt een inbreuk die kan leiden tot burgerlijke en strafrechtelijke aansprakelijkheid.',
  authorizedUse: 'Toegestaan Gebruik',
  authorizedUseText: 'U mag de inhoud van de Website alleen raadplegen en afdrukken voor strikt persoonlijk, privé en niet-commercieel gebruik.',
  intellectualPropertySectionText3: 'Alle handelsmerken, logo\'s en andere onderscheidende tekens die op de Website worden weergegeven, zijn gedeponeerde handelsmerken van Ktran of zijn partners. Elk gebruik zonder voorafgaande toestemming is verboden.',
  
  // Responsabilité
  responsibilitySection: 'Aansprakelijkheid',
  responsibilitySectionText1: 'Ktran streeft ernaar nauwkeurige en actuele informatie op de Website te verstrekken. Wij kunnen echter niet garanderen dat alle informatie foutloos, volledig of actueel is.',
  responsibilitySectionText2: 'Ktran kan niet aansprakelijk worden gesteld voor:',
  responsibilityList1: 'Directe of indirecte schade die voortvloeit uit het gebruik of de onmogelijkheid om de Website te gebruiken',
  responsibilityList2: 'Tijdelijke onbeschikbaarheid van de Website wegens technische problemen',
  responsibilityList3: 'Eventuele fouten, weglatingen of onnauwkeurigheden in de verstrekte informatie',
  responsibilityList4: 'Schade veroorzaakt door virussen of andere schadelijke elementen',
  responsibilityList5: 'Verlies van gegevens of winstderving',
  responsibilityList6: 'Inhoud van externe websites waarnaar wordt gelinkt',
  forceMajeure: 'Overmacht',
  forceMajeureText: 'Ktran kan niet aansprakelijk worden gesteld voor niet-nakoming van zijn verplichtingen wegens overmacht of onvoorziene omstandigheden buiten zijn controle.',
  
  // Liens hypertextes
  hyperlinksSection: 'Hyperlinks',
  hyperlinksSectionText1: 'De Website kan links naar externe websites van derden bevatten. Deze links worden verstrekt voor uw gemak. Ktran heeft geen controle over de inhoud van deze websites en kan niet aansprakelijk worden gesteld voor hun inhoud, beschikbaarheid of privacybeleid.',
  hyperlinksSectionText2: 'Het plaatsen van een link naar onze Website vanaf een andere website vereist voorafgaande schriftelijke toestemming van Ktran. Diepe links (links naar andere pagina\'s dan de homepage) zijn verboden zonder uitdrukkelijke toestemming.',
  
  // Protection des données
  dataProtectionSection: 'Gegevensbescherming',
  dataProtectionSectionText1: 'De verwerking van uw persoonsgegevens is onderworpen aan ons',
  dataProtectionSectionText2: 'en aan de toepasselijke wetgeving inzake gegevensbescherming.',
  dataProtectionSectionText3: 'Voor vragen over de verwerking van uw persoonsgegevens kunt u contact met ons opnemen via',
  
  // Cookies
  cookiesSection: 'Cookies',
  cookiesSectionText: 'De Website gebruikt cookies om uw gebruikerservaring te verbeteren. Voor meer informatie, raadpleeg ons',
  
  // Modification des CGU
  termsModification: 'Wijziging van de Gebruiksvoorwaarden',
  termsModificationText1: 'Ktran behoudt zich het recht voor deze gebruiksvoorwaarden te allen tijde te wijzigen. Wijzigingen worden op deze pagina gepubliceerd en zijn van kracht vanaf hun publicatie.',
  termsModificationNote: 'Wij raden u aan deze pagina regelmatig te raadplegen om op de hoogte te blijven van eventuele wijzigingen. Voortgezet gebruik van de Website na wijzigingen houdt in dat u de nieuwe voorwaarden aanvaardt.',
  
  // Droit applicable
  applicableLawSection: 'Toepasselijk Recht en Bevoegde Rechtbank',
  applicableLawSectionText1: 'Deze gebruiksvoorwaarden zijn onderworpen aan het Belgische recht.',
  applicableLawSectionText2: 'Bij geschillen die voortvloeien uit deze gebruiksvoorwaarden of het gebruik van de Website, zijn uitsluitend de rechtbanken van Brussel bevoegd, tenzij anders bepaald door dwingende wettelijke bepalingen.',
  amicableSettlement: 'Minnelijke Schikking',
  amicableSettlementText: 'In geval van een geschil verbinden de partijen zich ertoe eerst een minnelijke schikking na te streven voordat zij een beroep doen op de rechtbank.',
  
  // Contact
  contactUsSection: 'Neem Contact met Ons Op',
  contactUsSectionText: 'Voor vragen over deze gebruiksvoorwaarden kunt u contact met ons opnemen:',

  // ========== POLITIQUE DE COOKIES / COOKIEBELEID ==========
  cookiePolicyDescription: 'Hoe wij cookies gebruiken en hoe u ze kunt beheren',
  
  // Introduction
  whatIsCookie: 'Wat is een Cookie?',
  cookieDefinition: 'Een cookie is een klein tekstbestand dat op uw apparaat (computer, tablet, smartphone) wordt opgeslagen wanneer u een website bezoekt. Cookies stellen de website in staat uw voorkeuren te onthouden en uw gebruikerservaring te verbeteren.',
  
  // Types de cookies
  cookieTypesTitle: 'Soorten Cookies die Wij Gebruiken',
  
  essentialCookiesTitle: 'Essentiële Cookies',
  essentialCookiesDesc: 'Deze cookies zijn noodzakelijk voor de goede werking van de website. Ze stellen u in staat om te navigeren en de basisfuncties te gebruiken.',
  examples: 'Voorbeelden',
  sessionCookies: 'Sessiecookies voor authenticatie',
  securityCookies: 'Beveiligingscookies',
  languageCookies: 'Taalvoorkeuren',
  duration: 'Duur',
  sessionOrOneYear: 'Sessie of 1 jaar',
  consentRequired: 'Toestemming vereist',
  no: 'Nee',
  yes: 'Ja',
  necessaryForOperation: 'noodzakelijk voor de werking',
  
  functionalCookiesTitle: 'Functionele Cookies',
  functionalCookiesDesc: 'Deze cookies stellen de website in staat uw keuzes te onthouden (zoals uw gebruikersnaam, taal of regio) en verbeterde functies te bieden.',
  formPreferences: 'Formuliervoorkeuren',
  displayPreferences: 'Weergavevoorkeuren',
  navigationSettings: 'Navigatie-instellingen',
  upTo13Months: 'Tot 13 maanden',
  
  analyticsCookiesTitle: 'Analytische Cookies',
  analyticsCookiesDesc: 'Deze cookies helpen ons te begrijpen hoe bezoekers de website gebruiken, zodat we deze kunnen verbeteren.',
  collectedInfo: 'Verzamelde Informatie',
  trafficSource: 'Verkeersbron',
  navigationBehavior: 'Navigatiegedrag',
  anonymizedDemographics: 'Geanonimiseerde demografische gegevens',
  
  marketingCookiesTitle: 'Marketingcookies',
  marketingCookiesDesc: 'Wij gebruiken momenteel geen marketingcookies of cookies van derden voor advertentiedoeleinden.',
  
  // Cookies tiers
  thirdPartyCookies: 'Cookies van Derden',
  thirdPartyCookiesDesc: 'Onze website kan cookies van derden gebruiken voor specifieke diensten:',
  googleMapsDesc: 'Voor de weergave van interactieve kaarten en locatie.',
  hosting: 'Hosting',
  note: 'Opmerking',
  thirdPartyNote: 'Deze diensten hebben hun eigen privacybeleid. Wij raden u aan deze te raadplegen voor meer informatie over hun gebruik van cookies.',
  
  // Gestion des cookies
  manageCookiesTitle: 'Uw Cookies Beheren',
  viaBrowser: 'Via Uw Browser',
  browserConfigDesc: 'U kunt uw browser configureren om cookies te accepteren of te weigeren. Hier zijn de links naar de instructies voor de belangrijkste browsers:',
  
  refusalConsequences: 'Gevolgen van Weigering',
  refusalConsequencesDesc: 'Als u cookies weigert, kunnen sommige functies van de website niet correct werken:',
  cannotStayLoggedIn: 'U kunt niet ingelogd blijven',
  lossOfPreferences: 'Verlies van uw voorkeuren',
  formsNotSubmitting: 'Formulieren kunnen niet worden verzonden',
  degradedExperience: 'Verminderde gebruikerservaring',
  
  deletingCookies: 'Cookies Verwijderen',
  deletingCookiesDesc: 'U kunt te allen tijde de cookies die op uw apparaat zijn opgeslagen verwijderen via de instellingen van uw browser.',
  
  // Durée de conservation
  cookieType: 'Type Cookie',
  maxDuration: 'Maximale Duur',
  sessionCookiesType: 'Sessiecookies',
  untilBrowserClose: 'Tot sluiting van de browser',
  essentialCookiesType: 'Essentiële cookies',
  twelveMonths: '12 maanden',
  functionalCookiesType: 'Functionele cookies',
  thirteenMonths: '13 maanden',
  analyticsCookiesType: 'Analytische cookies',
  retentionGdprCompliance: 'Deze bewaartermijnen voldoen aan de aanbevelingen van de Europese autoriteiten voor gegevensbescherming (AVG).',
  
  // Base légale
  legalBasisDesc: 'Ons gebruik van cookies is gebaseerd op de volgende Europese en Belgische regelgeving:',
  gdprFull: 'Algemene Verordening Gegevensbescherming',
  ePrivacyDirective: 'ePrivacy-richtlijn',
  belgianLaw: 'Belgische wet van 13 juni 2005 betreffende elektronische communicatie',
  consentDesc: 'Voor niet-essentiële cookies vragen wij uw uitdrukkelijke toestemming via onze cookiebanner bij uw eerste bezoek aan de website.',
  
  // Contact
  questionsAboutCookies: 'Vragen over Cookies?',
  contactUsForQuestions: 'Voor vragen over ons gebruik van cookies kunt u contact met ons opnemen:',

  // ========== PROTECTION DES DONNÉES / GEGEVENSBESCHERMING ==========
  dataProtectionTitle: 'Gegevensbescherming',
  dataProtectionDescription: 'Onze technische en organisatorische maatregelen om uw gegevens te beschermen',
  
  // Introduction
  gdprCommitment: 'Onze Toewijding aan de AVG',
  gdprCommitmentText1: 'Ktran neemt de bescherming van uw persoonsgegevens zeer serieus. Wij verbinden ons ertoe de Algemene Verordening Gegevensbescherming (AVG) volledig na te leven.',
  gdprCommitmentText2: 'Deze pagina beschrijft in detail de technische en organisatorische maatregelen die wij hebben geïmplementeerd om de veiligheid, vertrouwelijkheid en integriteit van uw persoonsgegevens te waarborgen.',
  
  // Principes RGPD
  gdprPrinciples: 'Fundamentele Principes van de AVG',
  gdprPrinciplesText: 'Onze gegevensverwerkingspraktijken zijn gebaseerd op de zes fundamentele principes van de AVG:',
  lawfulnessTransparency: 'Rechtmatigheid en Transparantie',
  lawfulnessTransparencyDesc: 'Wij verwerken uw gegevens op een rechtmatige, eerlijke en transparante manier.',
  purposeLimitation: 'Doelbinding',
  purposeLimitationDesc: 'Gegevens worden verzameld voor specifieke, expliciete en legitieme doeleinden.',
  dataMinimization: 'Gegevensminimalisatie',
  dataMinimizationDesc: 'Wij verzamelen alleen de gegevens die strikt noodzakelijk zijn.',
  accuracy: 'Juistheid',
  accuracyDesc: 'Wij zorgen ervoor dat de gegevens nauwkeurig en actueel zijn.',
  storageLimitation: 'Opslagbeperking',
  storageLimitationDesc: 'Gegevens worden niet langer bewaard dan noodzakelijk.',
  integrityConfidentiality: 'Integriteit en Vertrouwelijkheid',
  integrityConfidentialityDesc: 'Wij implementeren passende beveiligingsmaatregelen.',
  
  // Mesures de sécurité techniques
  technicalSecurityMeasures: 'Technische Beveiligingsmaatregelen',
  technicalSecurityMeasuresText: 'Wij hebben robuuste technische maatregelen geïmplementeerd om uw gegevens te beschermen:',
  
  dataEncryption: 'Gegevensversleuteling',
  sslTls: 'SSL/TLS',
  sslTlsDesc: 'Alle gegevensoverdracht tussen uw browser en onze servers is versleuteld met SSL/TLS-protocollen.',
  encryptionAtRest: 'Versleuteling in Rust',
  encryptionAtRestDesc: 'Gevoelige gegevens worden versleuteld opgeslagen in onze databases.',
  secureProtocols: 'Beveiligde Protocollen',
  secureProtocolsDesc: 'Gebruik van moderne en veilige communicatieprotocollen (HTTPS, TLS 1.3).',
  
  accessControl: 'Toegangscontrole',
  strongAuthentication: 'Sterke Authenticatie',
  strongAuthenticationDesc: 'Toegang tot gegevens vereist sterke authenticatie met wachtwoorden en tokens.',
  leastPrivilege: 'Principe van Minimale Rechten',
  leastPrivilegeDesc: 'Elke gebruiker heeft alleen toegang tot de gegevens die noodzakelijk zijn voor zijn functie.',
  secureSessions: 'Beveiligde Sessies',
  secureSessionsDesc: 'Automatische uitloggen na inactiviteit en beveiligde sessiebeheer.',
  logging: 'Logboekregistratie',
  loggingDesc: 'Alle toegang tot gegevens wordt geregistreerd en gecontroleerd.',
  
  secureInfrastructure: 'Beveiligde Infrastructuur',
  certifiedHosting: 'Gecertificeerde Hosting',
  certifiedHostingDesc: 'Onze gegevens worden gehost bij Vercel, een AVG-conforme provider met EU-regios.',
  firewall: 'Firewall en Bescherming',
  firewallDesc: 'Geavanceerde firewalls en inbraakdetectiesystemen.',
  automaticBackups: 'Automatische Back-ups',
  automaticBackupsDesc: 'Dagelijkse back-ups met versleutelde opslag op meerdere locaties.',
  monitoring247: '24/7 Monitoring',
  monitoring247Desc: 'Continue monitoring van systemen om incidenten te detecteren.',
  
  threatProtection: 'Bescherming tegen Bedreigingen',
  antiMalware: 'Anti-malware',
  antiMalwareDesc: 'Bescherming tegen virussen, malware en andere bedreigingen.',
  ddosProtection: 'DDoS-bescherming',
  ddosProtectionDesc: 'Bescherming tegen denial-of-service-aanvallen.',
  inputValidation: 'Invoervalidatie',
  inputValidationDesc: 'Validatie van alle gebruikersinvoer om injectie-aanvallen te voorkomen.',
  regularUpdates: 'Regelmatige Updates',
  regularUpdatesDesc: 'Regelmatige updates van systemen en software om kwetsbaarheden te patchen.',
};